import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Typography } from "@mui/material";
import { useModals } from "hooks/shared-hooks/use-modals";

export const Head: React.FC = () => {
  const { closeFilesUploadModal } = useModals();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #dbe8f5",
        pb: "8px"
      }}
    >
      <Typography sx={{ fontSize: "18px", lineHeight: "24px", color: "#071f35" }}>Upload File</Typography>
      <IconButton onClick={closeFilesUploadModal}>
        <CloseIcon sx={{ fontSize: "24px" }} />
      </IconButton>
    </Box>
  );
};
